import { render, staticRenderFns } from "./credit_repayment_detail.vue?vue&type=template&id=08391b56&scoped=true"
import script from "./credit_repayment_detail.vue?vue&type=script&lang=js"
export * from "./credit_repayment_detail.vue?vue&type=script&lang=js"
import style0 from "./credit_repayment_detail.vue?vue&type=style&index=0&id=08391b56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08391b56",
  null
  
)

export default component.exports